import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20artistic%20illustration%20featuring%20premium%20golden%20butter%20blocks%20on%20a%20soft%20cream%20background%20with%20subtle%20wheat%20and%20grain%20textures%2C%20elegant%20minimalist%20composition%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20diffused%20lighting%2C%20artistic%20food%20illustration%20style%2C%20no%20text%2C%20clean%20aesthetic&width=1600&height=800&seq=hero-butter-main&orientation=landscape"
          alt="精选高品质黄油 - 黄油推荐"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white text-center max-w-3xl leading-tight">
          精选高品质黄油完整指南
        </h1>
        <p className="mt-4 md:mt-5 text-sm md:text-base text-white/85 text-center max-w-xl leading-relaxed">
          汇聚市面主流与小众优质黄油品牌，从风味、产地、用途到性价比全面评测，帮你告别选购困惑
        </p>
        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/buying-guide"
            className="px-6 py-2.5 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始选购指南
          </Link>
          <Link
            to="/category/brand-comparison"
            className="px-6 py-2.5 bg-white/15 backdrop-blur-sm text-white font-medium text-sm rounded-full hover:bg-white/25 transition-colors border border-white/20 whitespace-nowrap cursor-pointer"
          >
            查看品牌对比
          </Link>
        </div>
      </div>
    </section>
  );
}